import makeStyles from "@material-ui/styles/makeStyles";
import PropTypes from "prop-types";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const useStyles = makeStyles({
  dialogTitle: {
    padding: "24px 24px 16px 24px",
  },
  dialogContent: {
    padding: "0px 24px",
  },
  dialogActions: {
    padding: "16px 18px",
  },
});

export default function AlertDialog(props) {
  const classes = useStyles();
  const { onClose, open } = props;

  const handleClose = val => {
    onClose(val);
  };

  //

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      style={{ zIndex: 1300 }}
      {...props}
    >
      {props.title && (
        <DialogTitle
          id="alert-dialog-title"
          className={classes.dialogTitle}
        >
          {props.title}
        </DialogTitle>
      )}
      {props.header && (
        <DialogActions className={classes.dialogActions}>
          {props.header}
        </DialogActions>
      )}

      <DialogContent className={classes.dialogContent}>
        <DialogContentText component="span" id="alert-dialog-description">
          {props.body}
        </DialogContentText>
      </DialogContent>
      {props.footer && (
        <DialogActions className={classes.dialogActions}>
          {props.footer}
        </DialogActions>
      )}
    </Dialog>
  );
}

AlertDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
